import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axiosInstance from '../../axiosConfig';
import Notification from '../notification/Notification';
import '../../styles/Auth.css';

const ResetPassword = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [notification, setNotification] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleReset = async (e) => {
        e.preventDefault();

        if (newPassword.length < 4 || confirmPassword.length < 4) {
            setNotification({ message: 'Passwords must be at least 4 characters long.', isError: true });
            return;
        }

        if (newPassword !== confirmPassword) {
            setNotification({ message: 'Passwords do not match.', isError: true });
            return;
        }

        setLoading(true);
        try {
            const response = await axiosInstance.post('/api/auth/reset-password', { resetToken: token, newPassword });

            setNotification({ message: response.data.message, isError: false });

            // Redirect to login page after successful password reset
            setTimeout(() => {
                navigate('/login');
            }, 2000); // Adding a delay to show the success message before redirecting

        } catch (error) {
            const errorMessage = error.response?.data?.error || 'Error resetting password. Try again later.';
            setNotification({ message: errorMessage, isError: true });

            // Redirect to request password reset page if there was an error
            setTimeout(() => {
                navigate('/request-password-reset');
            }, 2000); // Adding a delay to show the error message before redirecting

        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="pass-container">
            <h2>Reset Password</h2>
            <form onSubmit={handleReset}>
                <input
                    className='reset-pass'
                    type="password"
                    placeholder="New Password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    disabled={loading}
                />
                <input
                    className='reset-pass'
                    type="password"
                    placeholder="Confirm Password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    disabled={loading}
                />
                <button type="submit" disabled={loading} className="auth-button">
                    {loading ? 'Resetting...' : 'Reset Password'}
                </button>
                {notification && (
                    <Notification
                        message={notification.message}
                        isError={notification.isError}
                        onClose={() => setNotification(null)}
                    />
                )}
            </form>
        </div>
    );
};

export default ResetPassword;
